<template>
  <div>
    <footer class="footer pb-3">
      <div class="container" style="text-align: center">
        <p class="text-muted pt-3"><span style="color: white;">© 2024 | Penzion u Zdichynců</span></p>
      </div>
    </footer>
  </div>
</template>

<script>
export default {
  name: "footer",
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>
